import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/aleksundshantu/toni-hofreiter-2026-frontend/apps/template-standard/src/app/layout.client.tsx");
;
import(/* webpackMode: "eager" */ "/builds/aleksundshantu/toni-hofreiter-2026-frontend/apps/template-standard/src/style.scss");
